import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Typography,
  Button,
  Box,
} from "@mui/material";

const FAQCard = ({ titulo, resumen, imagen, onVerMas }) => {
  const tieneImagen = Boolean(imagen);

  return (
    <Card
      sx={{
        position: "relative",
        maxWidth: 345,
        minHeight: 290,
        maxHeight: 290,
        margin: 2,
      }}
    >
      {tieneImagen ? (
        <CardMedia
          component="img"
          alt={titulo}
          height="180"
          image={imagen}
          sx={{ objectFit: "cover" }}
        />
      ) : (
        <Box
          height="140px"
          sx={{
            backgroundColor: "#eec0f7ff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#2b0234ff",
            fontSize: 16,
          }}
        >
          <Typography variant="h6" align="center">
            {titulo}
          </Typography>
        </Box>
      )}

      <CardContent>
        {tieneImagen ? (
          <Typography
            gutterBottom
            variant="h6"
            component="div"
            overflow={"hidden"}
          >
            {titulo}
          </Typography>
        ) : (
          <Typography
            component="div"
            sx={{ fontSize: "0.9rem", fontWeight: "bold" }}
          >
            {titulo}
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary">
          {resumen}
        </Typography>
      </CardContent>
      {/* Botón flotante a la izquierda */}
      <Box
        sx={{
          px: 2,
          pb: 1,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Button
          size="small"
          onClick={onVerMas}
          sx={{
            float: "right",
            position: "absolute",
            bottom: 4,
            right: 2,
            zIndex: 1000,
          }}
        >
          Ver más
        </Button>
        <Box sx={{ clear: "both" }} />
      </Box>
    </Card>
  );
};

export default FAQCard;
